import React, { Fragment } from 'react';
// import bg1 from '../../images/banner/b3.jpg';
import '../about/css/backimg.css';
import {Link} from 'react-router-dom';

const Backimg = () => {
    return (
        <Fragment>
            <div className="Backimg_Total">
               
                <div className="backtext">
                  <h2 >
                    we provide high quality{' '}
                    <span style={{ color: ' #f3072a' }}>work</span>{' '}
                  </h2>
                  <p >We're Technology Focused.</p>
                  <Link to='/work' className='btn'>view work</Link>
                
                </div>
            </div>
            
        </Fragment>
       
    )
}

export default Backimg;